import React from 'react';
import type { BottomTabScreenProps } from '@react-navigation/bottom-tabs';
import type { NativeStackScreenProps } from '@react-navigation/native-stack';
import type {
  MainTabParamList,
  RootStackParamList,
} from '../../constants/routes';
import { AdminDashboardScreen } from './AdminDashboardScreen';

type Props =
  | NativeStackScreenProps<RootStackParamList, 'TeamDashboard'>
  | BottomTabScreenProps<MainTabParamList, 'TeamDashboard'>;

/**
 * Team Lead dashboard — the HR Admin dashboard UI, with every metric and list
 * limited by the backend to the signed-in lead's assigned employees.
 */
export function TeamDashboardScreen(props: Props) {
  return <AdminDashboardScreen {...props} scope="team" />;
}
